import { Route, Switch, useRouteMatch, Redirect } from "react-router-dom";
import NestedSideNavigation from "../../components/organism/NestedSideNavigation";
import NotificationSettingsLayout from "./NotificationsSettingsLayout";
import OrganisationSettings from "./OrganisationSettings";
import useProfile from "../../services/utils/custom hooks/useProfile";
import CustomNavLinkProps from "../../services/models/customNavLinkProps.model";
import MyPreferencesPage from "./MyPreferencesPage";
import DeliveryHistoryPage from "./DeliveryHistoryPage";

function NotificationsSettingsPage() {
  const match = useRouteMatch();
  const profile = useProfile();
  const isPhysicianOnly =
    profile?.data?.user?.roles?.includes("Physician") &&
    profile?.data?.user?.roles?.length === 1;
  const links = [
    {
      to: `${match.path}/my-preferences`,
      name: "My preferences",
      isExact: false,
    },
    isPhysicianOnly
      ? null
      : {
          to: `${match.path}/organizations-settings`,
          name: "Organization preferences",
          isExact: false,
        },
    {
      to: `${match.path}/delivery-history`,
      name: "Communication log",
      isExact: false,
    },
  ].filter((link): link is CustomNavLinkProps => !!link);

  return (
    <NotificationSettingsLayout>
      <NestedSideNavigation links={links} />
      <div className="overflow-auto xs:row-span-2 md:row-span-1">
        <Switch>
          <Route
            exact
            path={match.path}
            render={() => <Redirect to={`${match.path}/my-preferences`} />}
          />
          <Route
            path={`${match.path}/my-preferences`}
            component={MyPreferencesPage}
          />
          <Route
            path={`${match.path}/delivery-history`}
            component={DeliveryHistoryPage}
          />
          <Route
            path={`${match.path}/organizations-settings`}
            component={OrganisationSettings}
          />
          <Route
            path={`${match.path}/communication-preferences`}
            render={() => <Redirect to={`${match.path}/my-preferences`} />}
          />
          {/* Personal settings stays hidden; redirect legacy URL to my-preferences */}
          <Route
            path={`${match.path}/personal-settings`}
            render={() => <Redirect to={`${match.path}/my-preferences`} />}
          />
        </Switch>
      </div>
    </NotificationSettingsLayout>
  );
}

export default NotificationsSettingsPage;
